import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.dimensions.personnel',
    'resource:data.dimensions.personnel.entities.employee',
    'resource:data.dimensions.personnel.entities.employee.attributes.person',
    'resource:data.dimensions.personnelLeaders',
    'resource:data.dimensions.personnelLeaders.entities.relationship',
    'resource:data.dimensions.personnelLeaders.entities.relationship.attributes.leader',
    'resource:data.dimensions.personnelLeaders.entities.relationship.attributes.personnel',
  ],
  description: 'TODO',
  name: 'Personnel',
} as const satisfies core.quiver.Package
